import React from 'react';

export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center justify-center overflow-hidden bg-gradient-to-br from-[#0a0a0a] via-[#1a1a1a] to-[#0f0f0f]">
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=aerial%20view%20of%20modern%20city%20skyline%20at%20golden%20hour%20sunset%20warm%20amber%20light%20rays%20streaming%20through%20buildings%20urban%20landscape%20professional%20photography%20cinematic%20lighting%20dramatic%20sky%20warm%20tones%20business%20district%20downtown%20cityscape&width=1920&height=1080&seq=hero-city-sunset-99&orientation=landscape"
          alt="City at sunset"
          className="w-full h-full object-cover object-top opacity-70"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/50"></div>
      </div>

      <div className="absolute top-1/4 right-1/4 w-96 h-96 bg-[#F49729]/20 rounded-full blur-[120px] z-0"></div>
      <div className="absolute bottom-1/3 right-1/3 w-64 h-64 bg-[#F49729]/10 rounded-full blur-[80px] z-0"></div>

      <div className="relative z-10 w-full px-6 lg:px-16 pt-32 sm:pt-28 md:pt-16 pb-32 md:pb-32">
        <div className="max-w-4xl">
          <p
            className="text-[#F49729] text-xs sm:text-sm font-semibold tracking-[0.25em] uppercase mb-4 md:mb-6 opacity-0"
            style={{ animation: 'fadeIn 0.8s ease-out 0s forwards' }}
          >
            Unlocking Global Potential
          </p>
          <h1 className="text-[clamp(2rem,8.5vw,6.2rem)] font-black text-white leading-[0.95] tracking-tighter mb-6 md:mb-10">
            <span
              className="block opacity-0 translate-y-8"
              style={{ animation: 'slideUp 0.8s ease-out 0.2s forwards' }}
            >
              ACCOUNTING
            </span>
            <span
              className="block opacity-0 translate-y-8"
              style={{ animation: 'slideUp 0.8s ease-out 0.4s forwards' }}
            >
              TALENT FOR
            </span>
            <span
              className="block text-[#F49729] drop-shadow-[0_0_40px_rgba(244,151,41,0.6)] opacity-0 translate-y-8"
              style={{ animation: 'slideUp 0.8s ease-out 0.6s forwards, glow 2s ease-in-out 1.4s infinite' }}
            >
              CPA FIRMS
            </span>
          </h1>
          <p
            className="text-sm md:text-lg lg:text-xl text-white/70 max-w-3xl leading-relaxed opacity-0 whitespace-normal md:whitespace-nowrap"
            style={{ animation: 'fadeIn 1s ease-out 1s forwards' }}
          >
            Vetted accountants and bookkeepers — hired in days, at a fraction of the cost.
          </p>
        </div>
      </div>

      <div className="absolute bottom-20 md:bottom-24 left-1/2 -translate-x-1/2 z-10 animate-bounce">
        <a
          href="#services"
          className="flex flex-col items-center gap-2 text-white/60 hover:text-white transition-colors cursor-pointer"
        >
          <span className="text-xs tracking-widest uppercase">Scroll</span>
          <i className="ri-arrow-down-line text-2xl"></i>
        </a>
      </div>

      <div className="absolute bottom-0 left-0 right-0 z-10" style={{ marginBottom: '-2px' }}>
        <svg
          viewBox="0 0 1440 60"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          className="w-full h-auto block"
          style={{ display: 'block' }}
        >
          <path d="M0 62L0 30C360 0 720 10 1080 30C1260 40 1380 50 1440 45L1440 62L0 62Z" fill="white" />
        </svg>
      </div>

      <style>{`
        @keyframes slideUp {
          from { opacity: 0; transform: translateY(40px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @keyframes fadeIn {
          from { opacity: 0; }
          to { opacity: 1; }
        }
        @keyframes glow {
          0%, 100% { filter: drop-shadow(0 0 40px rgba(244, 151, 41, 0.6)); }
          50% { filter: drop-shadow(0 0 60px rgba(244, 151, 41, 0.9)); }
        }
      `}</style>
    </section>
  );
}
